import { cn } from '@discover-lib/utils';
import StarIcon from '@discover-ui/icons/star.svg';
import Stars from './stars';
import Root, { type RootProps } from './root';

export type RestaurantRatingProps = {
  rating: number;
  count: number;
  starGap?: number;
  textClassName?: string;
  layout?: 'full' | 'compact';
} & Omit<RootProps, 'children'>;

export default function RestaurantRating({
  rating,
  count,
  className,
  starGap,
  textClassName,
  layout = 'full',
  ...props
}: RestaurantRatingProps) {
  const countLabel = count.toLocaleString();

  if (layout === 'compact') {
    return (
      <Root className={cn('gap-1 hover:underline', className)} {...props}>
        <span className="sr-only">User rating: </span>
        <StarIcon className="size-4 shrink-0 text-yellow-400" aria-hidden="true" />
        <span className={textClassName}>{rating.toFixed(1)}</span>
        <span>
          ({countLabel}
          <span className="sr-only"> reviews</span>)
        </span>
      </Root>
    );
  }

  return (
    <Root className={cn('hover:underline', className)} {...props}>
      <span className="sr-only">User rating: </span>
      <span className={cn('mt-0.5', textClassName)}>{rating.toFixed(1)}</span>
      <Stars className="mx-1.5" count={rating} gap={starGap} />
      <span className="-mt-0.5 leading-none">(</span>
      <span className={textClassName}>{countLabel}</span>
      <span className="sr-only"> reviews</span>
      <span className="-mt-0.5 leading-none">)</span>
    </Root>
  );
}
